import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const FormItem = () => {
  return (
    <Box gap="s8">
      <Skeleton width="s120" height="s12" />
      <Skeleton width="s300" height="s32" />
    </Box>
  )
}

const LoadingForm = ({ items }: { items: number }) => {
  return (
    <Box
      gap="s32"
      padding="s24"
      border={{
        all: {
          width: 's2',
          color: 'grey200',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      height="full"
      width="s400"
      alignItems="center"
    >
      <Box gap="s8" alignItems="center">
        <Skeleton width="s240" height="s12" />
        <Skeleton width="s140" height="s12" />
      </Box>
      {Array.from({ length: items }).map((_, index) => (
        <FormItem key={index} />
      ))}
    </Box>
  )
}

const LoadingDescription = () => {
  return (
    <Box gap="s24" flexDirection="column">
      <Skeleton width="s32" height="s32" />
      <Skeleton width="s200" height="s16" />
      <Skeleton width="s400" height="s12" />
    </Box>
  )
}

const LargeBlock = () => {
  return <LoadingBlock items={10} />
}

const MediumBlock = () => {
  return <LoadingBlock items={5} />
}

const SimpleBlock = () => {
  return <LoadingBlock items={1} />
}

const LoadingBlock = ({ items }: { items: number }) => {
  return (
    <Box gap="s32" flexDirection="row" justifyContent="spaceBetween">
      <LoadingDescription />
      <LoadingForm items={items} />
    </Box>
  )
}

const LoadingState = () => {
  return (
    <Box
      paddingTop="s40"
      style={{
        position: 'relative',
        gridColumnStart: '2',
        gridColumnEnd: 'span 10',
      }}
      paddingBottom="s48"
      gridColSpan={{ xxs: 10 }}
      gap="s40"
    >
      <Box gap="s32">
        <LargeBlock />
        <SimpleBlock />
        <MediumBlock />
        <MediumBlock />
      </Box>
    </Box>
  )
}

export default LoadingState
